import { initMenu } from "../behaviors/menu.js";
import { initStickyHeader } from "../behaviors/sticky-header.js";
import { initSmoothScroll } from "../behaviors/smooth-scroll.js";
import { initMetrika } from "../behaviors/metrika.js";
import { initSocialLinks } from "../behaviors/social-links.js";
import { initCopyButtons } from "../behaviors/copy-button.js";

export function initSharedBehaviors() {
  initMenu();
  initStickyHeader();
  initSmoothScroll();
  initMetrika();
  initSocialLinks();
  initCopyButtons();
}
